// FE-03 连接状态常量 + 任务事件订阅薄封装。
// SSE 实现统一在 src/utils/sse（FE-04 官方实现：解析/URL/token/重连/Last-Event-ID 续传），
// 本文件只保留 store 层需要的状态机常量与对 subscribeTaskEvents 的适配封装。

import { subscribeTaskEvents } from '@/utils/sse';

export const CONNECTION_IDLE = 'idle';
export const CONNECTION_CONNECTING = 'connecting';
export const CONNECTION_CONNECTED = 'connected';
export const CONNECTION_RECONNECTING = 'reconnecting';
export const CONNECTION_DISCONNECTED = 'disconnected';
export const CONNECTION_ERROR = 'error';

// 建立任务事件订阅。onEvent(event) 收到规范化事件（见 @/utils/sse/parser 的 parseEvent）；
// onStatus(status, error) 通知连接状态变化（CONNECTED / RECONNECTING / DISCONNECTED / ERROR）。
// 返回 { signal, abort, close }，调用方可中断连接。
export function connectTaskEvents(taskId, { onEvent, onStatus, ...rest } = {}) {
  const controller = new AbortController();
  const conn = subscribeTaskEvents({
    taskId,
    signal: controller.signal,
    ...rest,
    onEvent,
    onReconnect: () => {
      if (typeof onStatus === 'function') {
        onStatus(CONNECTION_RECONNECTING);
      }
    },
    onReconnectSuccess: () => {
      if (typeof onStatus === 'function') {
        onStatus(CONNECTION_CONNECTED);
      }
    },
    onError: (error) => {
      if (typeof onStatus === 'function') {
        onStatus(CONNECTION_ERROR, error);
      }
    },
    onComplete: () => {
      if (typeof onStatus === 'function') {
        onStatus(CONNECTION_DISCONNECTED);
      }
    },
  });
  // 订阅已发起（fetch 已建立），视为已连接；后续结束/错误由 onComplete/onError 驱动
  if (typeof onStatus === 'function') {
    onStatus(CONNECTION_CONNECTED);
  }
  const abort = () => {
    conn.close();
    controller.abort();
    if (typeof onStatus === 'function') {
      onStatus(CONNECTION_DISCONNECTED);
    }
  };
  return {
    signal: controller.signal,
    abort,
    close: abort,
  };
}